module.exports = __webpack_public_path__ + "static/media/slide_07.fac14720.jpg";